import React, { useCallback, useState } from 'react';
import axios from '../modules/api';
import http from '../modules/api';
import * as StyleUtil from '../modules/utils/StyleUtil';
import {Line} from 'react-chartjs-2';
import { NavLink, Link, Prompt } from 'react-router-dom';
import $ from 'jquery';
import Slider from "react-slick";
import plus_img from '../../resources/img/plus.svg';
import ConfirmDialogV2 from '../modules/dialogs/ConfirmDialogV2';
import BasicDialogV2 from '../modules/dialogs/BasicDialogV2';
import CheckBox from '../modules/common/CheckBox';

import ReactGA, { send } from 'react-ga';
import TitleContentDialogV2 from "../modules/dialogs/TitleContentDialogV2";
ReactGA.initialize('UA-78553461-8', {
    titleCase: false,
});

let window_scrollTop; // 스크롤 위치

export class RpFavoriteAlgorithm_v2 extends React.Component {
    constructor(props) {
		super(props);
		this.state = {
            favorite_algorithm_list: [],
            checked_list: [],
            filter_page_id: "-1"
        }
    }

    componentWillMount() {

    }

	componentDidMount() {
       this.loadFavoriteAlgorithmList();
    }

    componentDidUpdate() {
    }

    componentWillUnmount(e) {

    }

    /** 자주 사용하는 알고리즘 목록 조회 */
    loadFavoriteAlgorithmList () {
        this.setState({
            favorite_algorithm_list : [],
            checked_list : [],
        }, () => {
            http.get("/rest/shop/rp/favorite/algorithm/list?filter_page_id="+this.state.filter_page_id) 
            // 백엔드에서 filter_page_id가 적용되는 부분은 쿼리 rpMapper.selectRpEventFavoriteAlgorithmList 참고
            .then(res => {
                const list = res.data.list;
                this.setState({
                    favorite_algorithm_list : list
                });
            })
            .catch(error => {
            });
        });
    }

    // cafe24 진열 등록 페이지로 이동
    onCklicBtnRegistPage(e, favorite_algorithm_seq, iframe_page_id, cafe24_category_display_group){
        // setGaEvent("메인 진열 등록 클릭");
        this.props.history.push(
            {
                pathname: iframe_page_id.indexOf("cafe24") >= 0
                ? iframe_page_id == "robomd_cafe24_main_page"
                    ?  `/shop/rp/event/product/cafe24List/16006?favorite_algorithm_seq=${favorite_algorithm_seq}`
                    :  `/shop/rp/event/product/cafe24List/16009?cafe24_category_display_group=${cafe24_category_display_group}&favorite_algorithm_seq=${favorite_algorithm_seq}`
                : `/shop/rp/event/product/list?favorite_algorithm_seq=${favorite_algorithm_seq}`,
                state: { highlightType: "ranking" }
            }
        )
    }

    // cafe24 메인 진열 등록 페이지로 이동
    addMainList(e){
        // setGaEvent("메인 진열 등록 클릭");
        this.props.history.push(
            {
                pathname: sessionStorage.getItem("solution_type_cd") == "09001"
                ? `/shop/rp/event/product/cafe24List/16006`
                : `/shop/rp/event/product/list`,
                state: { highlightType: "ranking" }
            }
        )
    }

    // 목록 개별 선택
    checkOneRpAlgorithmListOnChange(e) {
        const {favorite_algorithm_list, checked_list} = this.state;
        let idx = e.target.value;

        if(e.target.checked) {
            checked_list.push(favorite_algorithm_list[idx]);
        }else{
            for(var rp in checked_list) {
                if(checked_list[rp].seq == favorite_algorithm_list[idx].seq){
                    checked_list.splice(rp, 1);
                    break;
                }
            }
        }

        this.setState({
            checked_list: checked_list,
        });
    }

    onClickBtnDelete() {
        const {list, checked_list} = this.state;
        let delete_list = [];

        if(checked_list != null && checked_list.length > 0){
            checked_list.map((obj) => {
                delete_list.push(obj);
            });
        }

        for(var idx in delete_list){
            console.log(delete_list[idx])
        }

        const config = {
            headers: {'Content-Type': 'application/json'}
        };
        const url = '/rest/shop/rp/favorite/algorithm/delete';
        const body = {
            list : delete_list
        };

        if (delete_list != null && delete_list.length > 0) {
            this.setState({
                delete_dialog_show_state: true,
                delete_dialog_content: "선택하신 알고리즘을 삭제하시겠습니까?",
                delete_dialog_button_list: [
                    {
                        title: "확인",
                        type: "1",
                        event_method: () => {
                            http
                                .post(url, body, config)
                                .then((res) => {
                                    if (res.data.delete_cnt > 0) {
                                        this.setState({
                                            delete_dialog_show_state: false,
                                            checked_list: [],
                                        }, () => {
                                            this.setState({
                                                basic_dialog_show_state : true,
                                                basic_dialog_content: "삭제가 완료되었습니다.",
                                                basic_dialog_button_list: [
                                                    {
                                                        title: "확인",
                                                        type: "1",
                                                        event_method: () => {
                                                            //팝업 닫기
                                                            this.setState({ basic_dialog_show_state: false });
                                                            StyleUtil.clearPopupNoneScroll(window_scrollTop);
                                                        }
                                                    }
                                                ],
                                            });

                                            StyleUtil.clearPopupNoneScroll(window_scrollTop);
                                            this.loadFavoriteAlgorithmList();
                                        });

                                    } else {
                                        alert("삭제에 실패하였습니다.");
                                        this.setState({
                                            delete_dialog_show_state: false
                                        });
                                    }
                                })
                                .catch((error) => {
                                    alert("삭제에 실패하였습니다.");
                                    this.setState({
                                        delete_dialog_show_state: false
                                    });
                                    console.log(error);
                                });
                        }
                    },
                    {
                        title: "취소",
                        type: "0",
                        event_method: () => {
                            this.setState({
                                delete_dialog_show_state: false
                            });
                        }
                    }
                ]
            });
        }else {
            alert("삭제할 알고리즘을 선택해주세요.");
        }
    }

    onCliclFilter(name) {
        this.setState({
            filter_page_id: name
        }, () => {
            this.loadFavoriteAlgorithmList ();
        })
    }

    render() {
        return (
            <>
                <div id='common-page-wrapper' className="style_guide_v2">
                    <div id="list_wrap" className="list_wrap_background" style={{overflowY:"auto"}}>
                        <div className="algorithm_list_wrap">
                            <div className="titleArea">
                                <div className='title'>자주쓰는 알고리즘</div>
                                <div className='content'>자동진열설정에서 저장해 놓은 자주 쓰는 자동진열 알고리즘 설정정보를 모두 모아서 관리하고 등록 할 수 있습니다</div>
                            </div>
                            <div className='flexBox algorithm_option_area' style={{justifyContent: "space-between"}}>
                                <div className="algorithm_filter_area">
                                    {   
                                        sessionStorage.getItem("solution_type_cd") == "09001"
                                        ?
                                            <>
                                            <div className={this.state.filter_page_id == "-1" ? "active" : ""}
                                            onClick={() => {
                                                this.onCliclFilter("-1");
                                            }
                                            }>전체</div>
                                            <div className={this.state.filter_page_id == "cafe24_main_page" ? "active" : ""}
                                            onClick={() => {
                                                this.onCliclFilter("cafe24_main_page");
                                            }
                                            }>메인</div>
                                            <div className={this.state.filter_page_id == "cafe24_category_page" ? "active" : ""}
                                            onClick={() => {
                                                this.onCliclFilter("cafe24_category_page");
                                            }
                                            }>카테고리</div>
                                            </>
                                        :   ""
                                    }
                                    <div className={this.state.filter_page_id == "widget" ? "active" : ""}
                                    onClick={() => {
                                        this.onCliclFilter("widget");
                                    }
                                    }>위젯</div>
                                </div>
                                <div className='algorithm_filter_area mobile_display_none' >
                                    <div className='icn_btn_area' onClick={e=>this.addMainList(e)}>
                                        <svg width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
                                            <path d="M18 9C18 9.19891 17.921 9.38968 17.7803 9.53033C17.6397 9.67098 17.4489 9.75 17.25 9.75H9.75V17.25C9.75 17.4489 9.67098 17.6397 9.53033 17.7803C9.38968 17.921 9.19891 18 9 18C8.80109 18 8.61032 17.921 8.46967 17.7803C8.32902 17.6397 8.25 17.4489 8.25 17.25V9.75H0.75C0.551088 9.75 0.360322 9.67098 0.21967 9.53033C0.0790178 9.38968 0 9.19891 0 9C0 8.80109 0.0790178 8.61032 0.21967 8.46967C0.360322 8.32902 0.551088 8.25 0.75 8.25H8.25V0.75C8.25 0.551088 8.32902 0.360322 8.46967 0.21967C8.61032 0.0790178 8.80109 0 9 0C9.19891 0 9.38968 0.0790178 9.53033 0.21967C9.67098 0.360322 9.75 0.551088 9.75 0.75V8.25H17.25C17.4489 8.25 17.6397 8.32902 17.7803 8.46967C17.921 8.61032 18 8.80109 18 9Z" fill="#63666A"/>
                                        </svg>
                                    </div>
                                    <div className='icn_btn_area' onClick={()=>this.onClickBtnDelete()}>
                                        <svg width="18" height="20" viewBox="0 0 18 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                                            <path d="M17.25 3H13.5V2.25C13.5 1.65326 13.2629 1.08097 12.841 0.65901C12.419 0.237053 11.8467 0 11.25 0H6.75C6.15326 0 5.58097 0.237053 5.15901 0.65901C4.73705 1.08097 4.5 1.65326 4.5 2.25V3H0.75C0.551088 3 0.360322 3.07902 0.21967 3.21967C0.0790178 3.36032 0 3.55109 0 3.75C0 3.94891 0.0790178 4.13968 0.21967 4.28033C0.360322 4.42098 0.551088 4.5 0.75 4.5H1.5V18C1.5 18.3978 1.65804 18.7794 1.93934 19.0607C2.22064 19.342 2.60218 19.5 3 19.5H15C15.3978 19.5 15.7794 19.342 16.0607 19.0607C16.342 18.7794 16.5 18.3978 16.5 18V4.5H17.25C17.4489 4.5 17.6397 4.42098 17.7803 4.28033C17.921 4.13968 18 3.94891 18 3.75C18 3.55109 17.921 3.36032 17.7803 3.21967C17.6397 3.07902 17.4489 3 17.25 3ZM6 2.25C6 2.05109 6.07902 1.86032 6.21967 1.71967C6.36032 1.57902 6.55109 1.5 6.75 1.5H11.25C11.4489 1.5 11.6397 1.57902 11.7803 1.71967C11.921 1.86032 12 2.05109 12 2.25V3H6V2.25ZM15 18H3V4.5H15V18ZM7.5 8.25V14.25C7.5 14.4489 7.42098 14.6397 7.28033 14.7803C7.13968 14.921 6.94891 15 6.75 15C6.55109 15 6.36032 14.921 6.21967 14.7803C6.07902 14.6397 6 14.4489 6 14.25V8.25C6 8.05109 6.07902 7.86032 6.21967 7.71967C6.36032 7.57902 6.55109 7.5 6.75 7.5C6.94891 7.5 7.13968 7.57902 7.28033 7.71967C7.42098 7.86032 7.5 8.05109 7.5 8.25ZM12 8.25V14.25C12 14.4489 11.921 14.6397 11.7803 14.7803C11.6397 14.921 11.4489 15 11.25 15C11.0511 15 10.8603 14.921 10.7197 14.7803C10.579 14.6397 10.5 14.4489 10.5 14.25V8.25C10.5 8.05109 10.579 7.86032 10.7197 7.71967C10.8603 7.57902 11.0511 7.5 11.25 7.5C11.4489 7.5 11.6397 7.57902 11.7803 7.71967C11.921 7.86032 12 8.05109 12 8.25Z" fill="#63666A"/> 
                                        </svg>
                                    </div>
                                </div>
                            </div>
                            <div className='mobile_icn_btn_area'>
                                <svg width="12" height="12" viewBox="0 0 11 11" fill="none" xmlns="http://www.w3.org/2000/svg" onClick={e=>this.addMainList(e)}>
                                    <path d="M10.375 5.5C10.375 5.60774 10.3322 5.71108 10.256 5.78726C10.1798 5.86345 10.0765 5.90625 9.96875 5.90625H5.90625V9.96875C5.90625 10.0765 5.86345 10.1798 5.78726 10.256C5.71108 10.3322 5.60774 10.375 5.5 10.375C5.39226 10.375 5.28892 10.3322 5.21274 10.256C5.13655 10.1798 5.09375 10.0765 5.09375 9.96875V5.90625H1.03125C0.923506 5.90625 0.820175 5.86345 0.743988 5.78726C0.667801 5.71108 0.625 5.60774 0.625 5.5C0.625 5.39226 0.667801 5.28892 0.743988 5.21274C0.820175 5.13655 0.923506 5.09375 1.03125 5.09375H5.09375V1.03125C5.09375 0.923506 5.13655 0.820175 5.21274 0.743988C5.28892 0.667801 5.39226 0.625 5.5 0.625C5.60774 0.625 5.71108 0.667801 5.78726 0.743988C5.86345 0.820175 5.90625 0.923506 5.90625 1.03125V5.09375H9.96875C10.0765 5.09375 10.1798 5.13655 10.256 5.21274C10.3322 5.28892 10.375 5.39226 10.375 5.5Z" fill="#333333"/>
                                </svg>
                                <svg width="14" height="16" viewBox="0 0 13 15" fill="none" xmlns="http://www.w3.org/2000/svg" style={{marginLeft:"30px"}} onClick={()=>this.onClickBtnDelete()}>
                                    <path d="M12.2742 3.00039H9.64922V2.47539C9.64922 2.05767 9.48328 1.65707 9.18791 1.3617C8.89254 1.06633 8.49193 0.900391 8.07422 0.900391H4.92422C4.5065 0.900391 4.10589 1.06633 3.81052 1.3617C3.51516 1.65707 3.34922 2.05767 3.34922 2.47539V3.00039H0.724219C0.58498 3.00039 0.451444 3.0557 0.352988 3.15416C0.254531 3.25262 0.199219 3.38615 0.199219 3.52539C0.199219 3.66463 0.254531 3.79816 0.352988 3.89662C0.451444 3.99508 0.58498 4.05039 0.724219 4.05039H1.24922V13.5004C1.24922 13.7789 1.35984 14.0459 1.55676 14.2429C1.75367 14.4398 2.02074 14.5504 2.29922 14.5504H10.6992C10.9777 14.5504 11.2448 14.4398 11.4417 14.2429C11.6386 14.0459 11.7492 13.7789 11.7492 13.5004V4.05039H12.2742C12.4135 4.05039 12.547 3.99508 12.6454 3.89662C12.7439 3.79816 12.7992 3.66463 12.7992 3.52539C12.7992 3.38615 12.7439 3.25262 12.6454 3.15416C12.547 3.0557 12.4135 3.00039 12.2742 3.00039ZM4.39922 2.47539C4.39922 2.33615 4.45453 2.20262 4.55299 2.10416C4.65144 2.0057 4.78498 1.95039 4.92422 1.95039H8.07422C8.21346 1.95039 8.34699 2.0057 8.44545 2.10416C8.54391 2.20262 8.59922 2.33615 8.59922 2.47539V3.00039H4.39922V2.47539ZM10.6992 13.5004H2.29922V4.05039H10.6992V13.5004ZM5.44922 6.67539V10.8754C5.44922 11.0146 5.39391 11.1482 5.29545 11.2466C5.19699 11.3451 5.06346 11.4004 4.92422 11.4004C4.78498 11.4004 4.65144 11.3451 4.55299 11.2466C4.45453 11.1482 4.39922 11.0146 4.39922 10.8754V6.67539C4.39922 6.53615 4.45453 6.40262 4.55299 6.30416C4.65144 6.2057 4.78498 6.15039 4.92422 6.15039C5.06346 6.15039 5.19699 6.2057 5.29545 6.30416C5.39391 6.40262 5.44922 6.53615 5.44922 6.67539ZM8.59922 6.67539V10.8754C8.59922 11.0146 8.54391 11.1482 8.44545 11.2466C8.34699 11.3451 8.21346 11.4004 8.07422 11.4004C7.93498 11.4004 7.80144 11.3451 7.70299 11.2466C7.60453 11.1482 7.54922 11.0146 7.54922 10.8754V6.67539C7.54922 6.53615 7.60453 6.40262 7.70299 6.30416C7.80144 6.2057 7.93498 6.15039 8.07422 6.15039C8.21346 6.15039 8.34699 6.2057 8.44545 6.30416C8.54391 6.40262 8.59922 6.53615 8.59922 6.67539Z" fill="#63666A"/>
                                </svg>
                            </div>
                            <div className="algorithm_table_area">
                                <table>
                                    <thead>
                                        <tr>
                                            <td className="list_td"></td>
                                            <td className="list_td">제목</td>
                                            <td className="list_td">등록페이지</td>
                                            <td className="list_td">등록날짜</td>
                                            <td className="list_td">저장</td>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        { this.state.favorite_algorithm_list != null && this.state.favorite_algorithm_list.length > 0
                                        ?   <>
                                            {
                                                this.state.favorite_algorithm_list.map((obj, idx) => (
                                                    <tr key={obj.iframe_page_id+'_'+obj.iframe_html_id} onClick={e => {this.onCklicBtnRegistPage(e, obj.seq, obj.iframe_page_id, obj.cafe24_category_display_group);}}>
                                                        <td onClick={e => {e.stopPropagation();}}>
                                                            <CheckBox
                                                                id={"list_algorithm_table_checkbox_" + (Number(idx))}
                                                                value={idx}
                                                                checked={this.state.checked_list.find(rp => rp.seq == obj.seq ) != null}
                                                                onChangeCheck={this.checkOneRpAlgorithmListOnChange.bind(this)}
                                                            />
                                                        </td>
                                                        <td>
                                                            {obj.algorithm_name}
                                                        </td>
                                                        <td>
                                                        {
                                                            obj.iframe_page_id == "robomd_cafe24_category_page" 
                                                            ? obj.iframe_page_simple_name
                                                                +   (obj.cafe24_category_display_group == "1" 
                                                                    ? " (일반)"
                                                                    : obj.cafe24_category_display_group == "2" 
                                                                        ? " (추천)"
                                                                        : obj.cafe24_category_display_group == "3" 
                                                                            ? " (신상)" 
                                                                            : "")
                                                            :   obj.iframe_page_id.indexOf("cafe24") >= 0
                                                                ? obj.iframe_page_simple_name
                                                                : "위젯"                 
                                                        }
                                                        </td>
                                                        <td>
                                                            {obj.reg_date_format}
                                                        </td>
                                                        <td>
                                                        <button class="selected_list_btn hover_white_mint btn_algorithm_regist" 
                                                        onClick={e => {
                                                            this.onCklicBtnRegistPage(e, obj.seq, obj.iframe_page_id, obj.cafe24_category_display_group);
                                                        }} tabIndex={-1}>등록</button>
                                                        </td>
                                                    </tr>
                                                ))
                                            }
                                            </>
                                        :
                                            ""
                                        }
                                    </tbody>
                                </table>
                            </div>

                            {/* 카드 영역: 모바일(800px 이하)에서만 보임 */}
                            { this.state.favorite_algorithm_list != null && this.state.favorite_algorithm_list.length > 0
                            ?   <>
                                {
                                    this.state.favorite_algorithm_list.map((obj, idx) => (
                                        <div className="algorithm_card">
                                            <div className="algorithm_card-header">
                                                <CheckBox
                                                    id={"list_algorithm_card_checkbox_" + (Number(idx))}
                                                    value={idx}
                                                    checked={this.state.checked_list.find(rp => rp.seq == obj.seq ) != null}
                                                    onChangeCheck={this.checkOneRpAlgorithmListOnChange.bind(this)}
                                                />
                                                <span className="algorithm_card-title">{obj.algorithm_name}</span>
                                            </div>
                                            <div className="algorithm_card-meta">
                                                <span>
                                                {
                                                    obj.iframe_page_id != "robomd_cafe24_category_page" 
                                                    ? obj.iframe_page_simple_name 
                                                    : obj.iframe_page_simple_name
                                                        +   (obj.cafe24_category_display_group == "1" 
                                                            ? " (일반)"
                                                            : obj.cafe24_category_display_group == "2" 
                                                                ? " (추천)"
                                                                : obj.cafe24_category_display_group == "3" 
                                                                    ? " (신상)" 
                                                                    : "")
                                                }
                                                </span>
                                                <span>{obj.reg_date_format}</span>
                                            </div>
                                            <button class="selected_list_btn hover_white btn_algorithm_regist" 
                                            onClick={e => {
                                                this.onCklicBtnRegistPage(e, obj.seq, obj.iframe_page_id, obj.cafe24_category_display_group);
                                            }} tabIndex={-1}>등록</button>
                                        </div>
                                    ))
                                }
                                </>
                            :
                                ""
                            }
                        </div>
                    </div>
                </div>
                {
					(this.state.confirm_dialog_show_state === true)
					? <ConfirmDialogV2
						content={this.state.confirm_dialog_content}
						button_list={this.state.confirm_dialog_button_list}
						popup_close={() => {
                            this.setState({confirm_dialog_show_state: false});
                            StyleUtil.clearPopupNoneScroll(window_scrollTop);
                        }}
					/>
					: ''
				}
                {
					(this.state.basic_dialog_show_state === true)
					? <BasicDialogV2
						content={this.state.basic_dialog_content}
						button_list={this.state.basic_dialog_button_list}
					/>
					: ''
				}
                {
                    (this.state.delete_dialog_show_state === true)
                        ? <ConfirmDialogV2
                            content={this.state.delete_dialog_content}
                            button_list={this.state.delete_dialog_button_list}
                            popup_close={() => {
                                this.setState({delete_dialog_show_state: false});
                                StyleUtil.clearPopupNoneScroll(window_scrollTop);
                            }}
                        />
                        : ''
                }
                {
                    (this.state.notice_period_title_content_dialog_show_state === true)
                        ? <TitleContentDialogV2
                            title={ this.state.is_finish == 0 ? this.state.remain_date+"일 뒤 "+this.state.payment_cls_text+"이 종료됩니다. <br/> 기간을 연장하시겠습니까?" : this.state.payment_cls_text+"이 종료되었습니다. <br/> 기간을 연장하시겠습니까?" }
                            content={this.state.payment_cls_text + " 기간<br/>" +  this.state.start_date_format + " ~ " + this.state.end_date_format}
                            button_list={this.state.title_content_dialog_button_list}
                            popup_close={() => {
                                this.setState({notice_period_title_content_dialog_show_state: false});
                            }}
                        />
                        : ''
                }
                {
                    (this.state.notice_delete_dialog_show_state === true)
                        ? <TitleContentDialogV2
                            content={this.state.notice_delete_dialog_content}
                            button_list={this.state.notice_delete_dialog_button_list}
                            popup_close={() => {
                                this.setState({notice_delete_dialog_show_state: false});
                                StyleUtil.clearPopupNoneScroll(window_scrollTop);
                            }}
                        />
                        : ''
                }
                {/* {this.state.tutorial_dialog_state &&
					<TitleContentDialogV2
						title={"로보MD 진열 사용하러 가볼까요?"}
						content={"다양한 자동 진열기능을 사용해 보시고<br/>자동 진열되는 상품결과를 미리보고 체험하세요."}
						button_list={[
                            {
                                title: "진열기능보기",
                                type: "1",
                                event_method: () => {
                                    this.addMainList();
                                    //팝업 닫기
                                    this.setState({
                                        tutorial_dialog_state: false,
                                        notice_period_title_content_dialog_show_state : false,
                                    });
                                    StyleUtil.clearPopupNoneScroll(window_scrollTop);
                                }
                            },
                            {
                                title: "닫기",
                                type: "0",
                                event_method: () => {
                                    //팝업 닫기
                                    this.setState({ tutorial_dialog_state: false });
                                    StyleUtil.clearPopupNoneScroll(window_scrollTop);
                                }
                            }
                        ]}
                        popup_close={() => {
                            this.setState({ tutorial_dialog_state: false });
                            StyleUtil.clearPopupNoneScroll(window_scrollTop);
                        }}
					/>
				} */}
            </>
        )
    };
    
}